export class CategoryNodeModel {
    id?: number = undefined
    idParent?: number = undefined
    name: string = ""
    value?: number = 0
    depth: number = 0
    allowExport: boolean = false
    isActive: boolean = false
    children: CategoryNodeModel[] = []
    loadingListAction: boolean = false

    constructor(c?: Partial<CategoryNodeModel>) {
        Object.assign(this, c)

        this._parseChildren()
    }

    private _parseChildren(): void {
        this.children = (this.children || []).map((c) => {
            return new CategoryNodeModel(c)
        })
    }
}
